/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type RevokeClusterInviteAuthClusterResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class RevokeClusterInviteAuthClusterResponse429ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: RevokeClusterInviteAuthClusterResponse429ResponseBodyData;

  constructor(
    err: RevokeClusterInviteAuthClusterResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "RevokeClusterInviteAuthClusterResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type RevokeClusterInviteAuthClusterResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class RevokeClusterInviteAuthClusterResponse409ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: RevokeClusterInviteAuthClusterResponse409ResponseBodyData;

  constructor(
    err: RevokeClusterInviteAuthClusterResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "RevokeClusterInviteAuthClusterResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type RevokeClusterInviteAuthClusterResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class RevokeClusterInviteAuthClusterResponse404ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: RevokeClusterInviteAuthClusterResponse404ResponseBodyData;

  constructor(
    err: RevokeClusterInviteAuthClusterResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "RevokeClusterInviteAuthClusterResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type RevokeClusterInviteAuthClusterResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class RevokeClusterInviteAuthClusterResponseResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: RevokeClusterInviteAuthClusterResponseResponseBodyData;

  constructor(
    err: RevokeClusterInviteAuthClusterResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "RevokeClusterInviteAuthClusterResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type RevokeClusterInviteAuthClusterResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class RevokeClusterInviteAuthClusterResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: RevokeClusterInviteAuthClusterResponseBodyData;

  constructor(
    err: RevokeClusterInviteAuthClusterResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "RevokeClusterInviteAuthClusterResponseBody";
  }
}

/**
 * Bad request
 */
export type RevokeClusterInviteResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class RevokeClusterInviteResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: RevokeClusterInviteResponseBodyData;

  constructor(
    err: RevokeClusterInviteResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "RevokeClusterInviteResponseBody";
  }
}

/** @internal */
export const RevokeClusterInviteAuthClusterResponse429ResponseBody$inboundSchema:
  z.ZodType<
    RevokeClusterInviteAuthClusterResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new RevokeClusterInviteAuthClusterResponse429ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type RevokeClusterInviteAuthClusterResponse429ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const RevokeClusterInviteAuthClusterResponse429ResponseBody$outboundSchema:
  z.ZodType<
    RevokeClusterInviteAuthClusterResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    RevokeClusterInviteAuthClusterResponse429ResponseBody
  > = z.instanceof(RevokeClusterInviteAuthClusterResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const RevokeClusterInviteAuthClusterResponse409ResponseBody$inboundSchema:
  z.ZodType<
    RevokeClusterInviteAuthClusterResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new RevokeClusterInviteAuthClusterResponse409ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type RevokeClusterInviteAuthClusterResponse409ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const RevokeClusterInviteAuthClusterResponse409ResponseBody$outboundSchema:
  z.ZodType<
    RevokeClusterInviteAuthClusterResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    RevokeClusterInviteAuthClusterResponse409ResponseBody
  > = z.instanceof(RevokeClusterInviteAuthClusterResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const RevokeClusterInviteAuthClusterResponse404ResponseBody$inboundSchema:
  z.ZodType<
    RevokeClusterInviteAuthClusterResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new RevokeClusterInviteAuthClusterResponse404ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type RevokeClusterInviteAuthClusterResponse404ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const RevokeClusterInviteAuthClusterResponse404ResponseBody$outboundSchema:
  z.ZodType<
    RevokeClusterInviteAuthClusterResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    RevokeClusterInviteAuthClusterResponse404ResponseBody
  > = z.instanceof(RevokeClusterInviteAuthClusterResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const RevokeClusterInviteAuthClusterResponseResponseBody$inboundSchema:
  z.ZodType<
    RevokeClusterInviteAuthClusterResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new RevokeClusterInviteAuthClusterResponseResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type RevokeClusterInviteAuthClusterResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const RevokeClusterInviteAuthClusterResponseResponseBody$outboundSchema:
  z.ZodType<
    RevokeClusterInviteAuthClusterResponseResponseBody$Outbound,
    z.ZodTypeDef,
    RevokeClusterInviteAuthClusterResponseResponseBody
  > = z.instanceof(RevokeClusterInviteAuthClusterResponseResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const RevokeClusterInviteAuthClusterResponseBody$inboundSchema:
  z.ZodType<RevokeClusterInviteAuthClusterResponseBody, z.ZodTypeDef, unknown> =
    z.object({
      message: z.string(),
      request$: z.instanceof(Request),
      response$: z.instanceof(Response),
      body$: z.string(),
    })
      .transform((v) => {
        return new RevokeClusterInviteAuthClusterResponseBody(v, {
          request: v.request$,
          response: v.response$,
          body: v.body$,
        });
      });

/** @internal */
export type RevokeClusterInviteAuthClusterResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const RevokeClusterInviteAuthClusterResponseBody$outboundSchema:
  z.ZodType<
    RevokeClusterInviteAuthClusterResponseBody$Outbound,
    z.ZodTypeDef,
    RevokeClusterInviteAuthClusterResponseBody
  > = z.instanceof(RevokeClusterInviteAuthClusterResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const RevokeClusterInviteResponseBody$inboundSchema: z.ZodType<
  RevokeClusterInviteResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new RevokeClusterInviteResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type RevokeClusterInviteResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const RevokeClusterInviteResponseBody$outboundSchema: z.ZodType<
  RevokeClusterInviteResponseBody$Outbound,
  z.ZodTypeDef,
  RevokeClusterInviteResponseBody
> = z.instanceof(RevokeClusterInviteResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
